import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Admin/Dashboard/dashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useDispatch, useSelector } from 'react-redux';
import { adminDashboard } from 'store/AdminDashboard/AdminDasboardAction';
import ReusableTabs from 'components/commom/Tab';
import DashboardPatientList from './DashboardPatientList';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import Loader from 'components/commom/Loader';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import MailIcon from 'assets/images/Dashboard/mail-request.svg';
import CallIcon from 'assets/images/Dashboard/call-request.svg';
import SwitchList from 'components/commom/SwitchList';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { doctorDetail } from 'routes/AppUrls';
import { getUpdateStatusValue } from 'store/providerStatus/providerStatusAction';
import { deletePatientData } from 'store/patientListDelete/patientListDeleteAction';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { getMasterData } from 'store/masterData/masterDataAction';
import DashboardData from './DashboardData';
import {
  basicDetailsValue,
  PROVIDER_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';
import CommonModal from 'components/commom/Modal';
import ReusableButton from 'components/commom/Button';
import CheckPromote from 'assets/images/Dashboard/check.svg';
import CrossIcon from 'assets/images/Dashboard/cross.svg';

const Dashboard = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [adminDashboardDetail, setAdminDashboardDetail] = useState([]);
  const [tab, setTab] = useState(1);
  const [selectDropCountry, setSelectDropCountry] = useState([]);
  const [selectDropState, setSelectDropState] = useState([]);
  const [selectDropCity, setSelectDropCity] = useState([]);
  const [doctorTitle, setDoctorTitle] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [formData, setFormData] = useState({
    countryValue: '',
    countryId: '',
    stateValue: '',
    stateId: '',
    cityValue: '',
    cityId: '',
    title: '',
    titleId: '',
  });

  const dashboardReducer = useSelector(
    (state) => state?.adminDashboardReducer?.loading
  );

  const loading = useSelector(
    (state) => state?.deletepatientListReducer?.loading
  );

  useEffect(() => {
    getDashboardData();
    dropDownValues();
    getTitleData();
  }, []);

  const getDashboardData = (
    pageValue,
    countryName,
    stateName,
    cityName,
    titleName
  ) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setAdminDashboardDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      adminDashboard(
        external,
        pageValue,
        countryName,
        stateName,
        cityName,
        titleName
      )
    );
  };

  const tabData = [
    { label: intl.formatMessage({ id: 'Providers' }) },
    { label: intl.formatMessage({ id: 'Patients' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
    setFormData((prev) => ({
      ...prev,
      countryValue: '',
      countryId: '',
      stateValue: '',
      stateId: '',
      cityValue: '',
      cityId: '',
      title: '',
      titleId: '',
    }));
    if (val === 1) {
      getDashboardData();
    }
  };

  const practiceNames = (item) => {
    return [
      item?.practice_area?.[0]?.practice_name,
      item?.practice_area?.[1]?.practice_name,
    ]
      .filter(Boolean)
      .join(',');
  };

  const dropDownValues = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSelectDropCountry(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getDoctorDrop(external));
  };

  const getTitleData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setDoctorTitle(res?.data);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(getMasterData(external, 'doctor-title'));
  };

  const handleInputChange = (event) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        if (name === 'countryValue') {
          setSelectDropState(res?.data);
        } else if (name === 'stateValue') {
          setSelectDropCity(res?.data);
        }
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
      ...(name === 'countryValue' && {
        countryId: value?.id,
        stateValue: '',
        stateId: '',
        cityValue: '',
        cityId: '',
        titleId: '',
        title: '',
      }),
      ...(name === 'stateValue' && {
        stateId: value?.id,
        cityValue: '',
        cityId: '',
      }),
      ...(name === 'cityValue' && { cityId: value?.id }),
      ...(name === 'title' && { titleId: value?.id }),
    }));

    const getProviderListWithParams = (countryId, stateId, cityId, titleId) => {
      getDashboardData(
        undefined,
        countryId || undefined,
        stateId || undefined,
        cityId || undefined,
        titleId
      );
    };

    if (name === 'title') {
      const { countryId, stateId, cityId } = formData || {};

      getProviderListWithParams(
        countryId || '',
        stateId || '',
        cityId || '',
        value?.id
      );
    } else if (name === 'countryValue') {
      dispatch(getDoctorDrop(external, value?.id));
      getProviderListWithParams(value?.id);
    } else if (name === 'stateValue') {
      dispatch(getDoctorDrop(external, formData?.countryId, value?.id));
      getProviderListWithParams(formData?.countryId, value?.id);
    } else if (name === 'cityValue') {
      getProviderListWithParams(
        formData?.countryId,
        formData?.stateId,
        value?.id
      );
    }
  };

  const handleChange = (id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        getDashboardData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {};
    dispatch(getUpdateStatusValue(external, id, body));
  };

  const handleDoctorDetail = (id) => {
    navigate(doctorDetail(locale));
    dispatch(basicDetailsValue(PROVIDER_ID, id));
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deleteProviderList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        getDashboardData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deletePatientData(external, deleteId));
  };

  const getUpdateValue = (value) => {
    if (value) {
      getDashboardData();
    }
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
            : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
        }
      >
        <DashboardData />

        <Col sm={12} md={12}>
          <div className="fs-20 pt-32 pb-12 fc-292D32 lh-20 family_outfit_semiBold_600">
            <FormattedMessage id="New Users" />
          </div>
        </Col>

        <Col md={12} lg={4} className="p-0">
          <ReusableTabs
            tabs={tabData}
            defaultTab={tab}
            currentTab={(val) => handleTabChange(val)}
            background={'#864629'}
            color={'#FFFFFF'}
            tabColor={'#A2A2A2'}
            completeColor={'#FFFFFF'}
            boxShadow={'0px 3px 16px 0px #00000014'}
          />
        </Col>

        {tab === 1 && (
          <div className="pt-16">
            {dashboardReducer ? (
              <Loader marginTop={'20vh'} />
            ) : (formData?.countryValue === '' ||
                formData?.stateValue === '' ||
                formData?.cityValue === '' ||
                formData?.title === '') &&
              adminDashboardDetail?.provider_list &&
              adminDashboardDetail?.provider_list?.length > 0 ? (
              <>
                <Row className="m-0 p-0 ">
                  <Col md={8} className="m-0 p-0 ">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center p-0"
                    >
                      <div className="fc-292D32 lh-201 family_outfit_medium_500">
                        Sort by:
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Country',
                          })}
                          name={'countryValue'}
                          value={formData?.countryValue}
                          data={selectDropCountry}
                          onChange={(e) => handleInputChange(e, 'countryValue')}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'State',
                          })}
                          name={'stateValue'}
                          value={formData?.stateValue}
                          data={selectDropState}
                          onChange={(e) => handleInputChange(e, 'stateValue')}
                          disabled={!formData?.countryValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'City',
                          })}
                          name={'cityValue'}
                          value={formData?.cityValue}
                          data={selectDropCity}
                          onChange={(e) => handleInputChange(e, 'cityValue')}
                          disabled={!formData?.stateValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Title',
                          })}
                          name={'title'}
                          value={formData?.title}
                          data={doctorTitle?.[0]?.values}
                          onChange={(e) => handleInputChange(e, 'title')}
                          background={'#FFFFFF'}
                          width={'276px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                    </Stack>
                  </Col>
                </Row>
                <div className="pt-20">
                  <Row className="listCustomHeader m-0 p-0 flex items-center">
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Patient & ID" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="City" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="State" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Practice" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Contact Info" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Status" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Medical Status" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Actions" />
                      </p>
                    </Col>
                  </Row>
                  <Row className="m-0 p-0">
                    {adminDashboardDetail?.provider_list.map((item, index) => {
                      return (
                        <Row className="m-0 p-0 flex items-center listAppointment">
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                              {item?.provider_name}
                            </div>
                            <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                              {item?.provider_id}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {item?.provider_city}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {item?.provider_state}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {practiceNames(item)}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <img src={MailIcon} alt="icon" />
                              <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                                {item?.provider_email}
                              </div>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center pt-04"
                            >
                              <img src={CallIcon} alt="icon" />
                              <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                                {item?.provider_country_code}{' '}
                                {item?.provider_phone}
                              </div>
                            </Stack>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <SwitchList
                              checked={item?.is_active}
                              onChange={(event) => handleChange(item?.id)}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </Col>
                          <Col
                            lg={1}
                            md={6}
                            sm={12}
                            className="flex justify-center"
                          >
                            {item?.active_status === true ? (
                              <Image src={CheckPromote} alt="icon" />
                            ) : (
                              <Image src={CrossIcon} alt="icon" />
                            )}
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={1}
                              className="items-center cursor-pointer"
                            >
                              <div
                                className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                                onClick={() => handleDoctorDetail(item?.id)}
                              >
                                <FormattedMessage id="View Details" />
                              </div>
                              <img
                                src={ArrowRightIcon}
                                alt="icon"
                                onClick={() => handleDoctorDetail(item?.id)}
                              />
                              <div className="pl-28">
                                <Image
                                  src={DeleteList}
                                  alt="icon"
                                  onClick={() => handleDeleteModal(item?.id)}
                                />
                              </div>
                            </Stack>
                          </Col>
                        </Row>
                      );
                    })}
                  </Row>
                </div>
              </>
            ) : (formData?.countryValue !== '' ||
                formData?.stateValue !== '' ||
                formData?.cityValue !== '' ||
                formData?.title !== '') &&
              adminDashboardDetail?.provider_list &&
              adminDashboardDetail?.provider_list?.length > 0 ? (
              <>
                <Row className="m-0 p-0 ">
                  <Col md={8} className="m-0 p-0 ">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center p-0"
                    >
                      <div className="fc-292D32 lh-201 family_outfit_medium_500">
                        Sort by:
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Country',
                          })}
                          name={'countryValue'}
                          value={formData?.countryValue}
                          data={selectDropCountry}
                          onChange={(e) => handleInputChange(e, 'countryValue')}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'State',
                          })}
                          name={'stateValue'}
                          value={formData?.stateValue}
                          data={selectDropState}
                          onChange={(e) => handleInputChange(e, 'stateValue')}
                          disabled={!formData?.countryValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'City',
                          })}
                          name={'cityValue'}
                          value={formData?.cityValue}
                          data={selectDropCity}
                          onChange={(e) => handleInputChange(e, 'cityValue')}
                          disabled={!formData?.stateValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Title',
                          })}
                          name={'title'}
                          value={formData?.title}
                          data={doctorTitle?.[0]?.values}
                          onChange={(e) => handleInputChange(e, 'title')}
                          background={'#FFFFFF'}
                          width={'276px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                    </Stack>
                  </Col>
                </Row>
                <div className="pt-20">
                  <Row className="listCustomHeader m-0 p-0 flex items-center">
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Patient & ID" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="City" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="State" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Practice" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Contact Info" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Status" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Medical Status" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Actions" />
                      </p>
                    </Col>
                  </Row>
                  <Row className="m-0 p-0">
                    {adminDashboardDetail?.provider_list.map((item, index) => {
                      return (
                        <Row className="m-0 p-0 flex items-center listAppointment">
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                              {item?.provider_name}
                            </div>
                            <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                              {item?.provider_id}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {item?.provider_city}
                            </div>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {item?.provider_state}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                              {practiceNames(item)}
                            </div>
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <img src={MailIcon} alt="icon" />
                              <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                                {item?.provider_email}
                              </div>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center pt-04"
                            >
                              <img src={CallIcon} alt="icon" />
                              <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                                {item?.provider_phone}
                              </div>
                            </Stack>
                          </Col>
                          <Col lg={1} md={6} sm={12}>
                            <SwitchList
                              checked={item?.is_active}
                              onChange={(event) => handleChange(item?.id)}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </Col>
                          <Col
                            lg={1}
                            md={6}
                            sm={12}
                            className="flex justify-center"
                          >
                            {item?.active_status === true ? (
                              <Image src={CheckPromote} alt="icon" />
                            ) : (
                              <Image src={CrossIcon} alt="icon" />
                            )}
                          </Col>
                          <Col lg={2} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={1}
                              className="items-center cursor-pointer"
                            >
                              <div
                                className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                                onClick={() => handleDoctorDetail(item?.id)}
                              >
                                <FormattedMessage id="View Details" />
                              </div>
                              <img
                                src={ArrowRightIcon}
                                alt="icon"
                                onClick={() => handleDoctorDetail(item?.id)}
                              />
                              <div className="pl-28">
                                <Image
                                  src={DeleteList}
                                  alt="icon"
                                  onClick={() => handleDeleteModal(item?.id)}
                                />
                              </div>
                            </Stack>
                          </Col>
                        </Row>
                      );
                    })}
                  </Row>
                </div>
              </>
            ) : (formData?.countryValue !== '' ||
                formData?.stateValue !== '' ||
                formData?.cityValue !== '' ||
                formData?.title !== '') &&
              adminDashboardDetail?.provider_list &&
              adminDashboardDetail?.provider_list?.length === 0 ? (
              <>
                <Row className="m-0 p-0 ">
                  <Col md={8} className="m-0 p-0 ">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center p-0"
                    >
                      <div className="fc-292D32 lh-201 family_outfit_medium_500">
                        Sort by:
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Country',
                          })}
                          name={'countryValue'}
                          value={formData?.countryValue}
                          data={selectDropCountry}
                          onChange={(e) => handleInputChange(e, 'countryValue')}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'State',
                          })}
                          name={'stateValue'}
                          value={formData?.stateValue}
                          data={selectDropState}
                          onChange={(e) => handleInputChange(e, 'stateValue')}
                          disabled={!formData?.countryValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'City',
                          })}
                          name={'cityValue'}
                          value={formData?.cityValue}
                          data={selectDropCity}
                          onChange={(e) => handleInputChange(e, 'cityValue')}
                          disabled={!formData?.stateValue?.length}
                          background={'#FFFFFF'}
                          width={'207px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                      <div>
                        <SelectInputBorder
                          placeholder={intl.formatMessage({
                            id: 'Title',
                          })}
                          name={'title'}
                          value={formData?.title}
                          data={doctorTitle?.[0]?.values}
                          onChange={(e) => handleInputChange(e, 'title')}
                          background={'#FFFFFF'}
                          width={'276px'}
                          colorIcon={'#292D32'}
                          placeholderColor={'#292D32'}
                        />
                      </div>
                    </Stack>
                  </Col>
                </Row>
                <div className="pt-20">
                  <Row className="listCustomHeader m-0 p-0 flex items-center">
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Patient & ID" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="City" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="State" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Practice" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Contact Info" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Status" />
                      </p>
                    </Col>
                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Medical Status" />
                      </p>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                        <FormattedMessage id="Actions" />
                      </p>
                    </Col>
                  </Row>
                </div>
                <div className="flex justify-center pt-120">
                  <div>
                    <Image src={EmptyScreen} alt="icon" />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex justify-center pt-120">
                <div>
                  <Image src={EmptyScreen} alt="icon" />
                  <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                    Nothing here yet
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {tab === 2 && (
          <DashboardPatientList getUpdateValue={(val) => getUpdateValue(val)} />
        )}
      </Col>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !loading && deleteProviderList();
                    }}
                    loading={loading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </Row>
  );
};

export default Dashboard;
